import { ButtonHTMLAttributes, useEffect, useState } from "react";
import { useSearchParams } from "next/navigation";
import { NO_OF_PROERTIES_PER_PAGE_IN_LISTING_PAGE } from "@/constant";
import WsChevronLeftIcon from "components/icons-svg/ChevronLeftIcon";
import ChevronRightIcon from "components/icons-svg/ChevronRightIcon";
import { useAppDispatch, useAppSelector } from "stores/hooks";
import { markSearch, selectSearch, setSearchQuery } from "stores/search/searchSlice";
import { generatePaginationMapping
// PAGINATION_MAPPER
} from "./paginationMapper";

// const MAX_PAGES = 15

const PaginationButton = ({
  children,
  isDisabled = false,
  isActive,
  ...rest
}: {
  isActive: boolean;
  isDisabled: boolean;
} & ButtonHTMLAttributes<HTMLButtonElement>) => {
  return <button disabled={isDisabled} className={`btn m-0 h-8 w-8 min-w-[2rem] px-0 font-semibold disabled:cursor-not-allowed disabled:opacity-50 ${isActive ? " bg-black-900 text-white  " : " bg-transparent text-grayText hover:bg-gray-100 hover:text-black-900 "}`} {...rest} data-sentry-component="PaginationButton" data-sentry-source-file="index.tsx">
      {children}
    </button>;
};
const NewPagination = ({
  totalPages,
  shouldUpdateUrl = true,
  onPageChange,
  count = 0
}: {
  onPageChange?: () => void;
  shouldUpdateUrl?: boolean;
  totalPages: number;
  count?: number;
}) => {
  const {
    page: currentPageIndex = 0
  } = useAppSelector(selectSearch);
  const searchParams = useSearchParams();
  const dispatch = useAppDispatch();

  // Generate pagination mapping.
  const paginationMap = generatePaginationMapping(totalPages);
  const onChange = (pageNumber: number) => {
    if (onPageChange) {
      onPageChange();
    }

    // will be set remaining item limit on last index page for nearby properties
    if (count < 1000 && searchParams?.get("nearByProperties") === "true" && totalPages === pageNumber) {
      const total = (totalPages - 1) * 21;
      const finalCount = count - total;
      dispatch(markSearch({
        limit: finalCount,
        page: pageNumber - 1 //to convert it to 0-based index
      }));
    } else {
      dispatch(markSearch({
        limit: NO_OF_PROERTIES_PER_PAGE_IN_LISTING_PAGE,
        page: pageNumber - 1 //to convert it to 0-based index
      }));
    }
    dispatch(setSearchQuery({
      shouldUpdateUrl
    }));
  };
  const [listOfPages, setListOfPages] = useState<number[]>();
  useEffect(() => {
    setListOfPages(paginationMap[totalPages.toString()]?.[(currentPageIndex + 1).toString()]);
  }, [currentPageIndex, totalPages]); // Do not add `paginationMap` here, it will save 7+ hours of debugging 🫡. (it will cause infinite loop)

  const currentPageNumber = currentPageIndex + 1;
  return <div className='inline-block w-1/2 p-2.5' data-sentry-component="NewPagination" data-sentry-source-file="index.tsx">
      <div className='flex justify-center gap-1 sm:gap-3 md:gap-4'>
        <PaginationButton aria-label='Previous Page' isActive={false} isDisabled={currentPageNumber <= 1} onClick={() => {
        onChange(currentPageNumber - 1);
      }} data-sentry-element="PaginationButton" data-sentry-source-file="index.tsx">
          <WsChevronLeftIcon title='paginationLeftChevronIcon' className='mr-0.5' data-sentry-element="WsChevronLeftIcon" data-sentry-source-file="index.tsx" />
        </PaginationButton>
        {listOfPages && listOfPages.map((pageNumber, index) => <div key={index}>
              {pageNumber === -1 && <div className='flex w-3 items-center justify-center font-semibold'>
                  ...
                </div>}
              {pageNumber !== -1 && <PaginationButton isActive={pageNumber === currentPageNumber} isDisabled={false} onClick={() => {
          if (pageNumber !== currentPageNumber) {
            onChange(pageNumber);
          }
        }}>
                  {`${pageNumber ? pageNumber : 1}`}
                </PaginationButton>}
            </div>)}
        <PaginationButton aria-label='Next Page' isActive={false}
      // isDisabled={currentPageNumber >= Math.min(MAX_PAGES, totalPages)}
      isDisabled={currentPageNumber >= totalPages} onClick={() => {
        onChange(currentPageNumber + 1);
      }} data-sentry-element="PaginationButton" data-sentry-source-file="index.tsx">
          <ChevronRightIcon className='ml-0.5' data-sentry-element="ChevronRightIcon" data-sentry-source-file="index.tsx" />
        </PaginationButton>
      </div>
    </div>;
};
export default NewPagination;